import { useEffect, useState } from "react";
import api from "../api/client";
type Provider = { namespace:string; registrationState:string };
export function useAzureProviders() {
  const [data, setData] = useState<Provider[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let mounted = true;
    api.get("/azure/providers")
      .then(r => mounted && setData(r.data?.value || []))
      .catch(e => mounted && setError(e.message))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);
  return { data, loading, error };
}
